/**
 * Created by bootdo.
 * 数据导入 api
 */
import * as API from '../'
import $const from '../../common/constant'

export default {

  /**
   * 查询导入状态
   * @param params
   * @returns {Promise<*>}
   */
  queryStatus: params => {
    return API.POST($const.apiServer.mall + '/dataImport/queryStatus', params);
  },

  /**
   * 获取导入企业列表（待状态）
   * @param params
   * @returns {Promise<*>}
   */
  improtEnterprises: params => {
    return API.GET($const.apiServer.mall + '/dataImport/improt-enterprises', params);
  },
}




// WEBPACK FOOTER //
// ./src/api/mall/api_data_import.js